import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import SelfSubUserGate from "@/components/SelfSubUserGate";

export function ProtectedRoute({ roles }) {
    const { user, ready } = useAuth();
    const location = useLocation();
    if (!ready) return <div className="p-10 text-navy-700">Loading…</div>;
    if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    const held = user.roles || [user.role];
    if (roles && !roles.some((r) => held.includes(r))) {
        // Land them in their currently-active portal.
        const active = user.active_role || user.role;
        const home =
            active === "admin"
                ? "/admin"
                : active === "broker"
                ? "/broker"
                : active === "affiliate"
                ? "/affiliate"
                : "/member";
        return <Navigate to={home} replace />;
    }
    // Legacy member accounts (signed up before the self-mirror sub_users
    // row existed) get a mandatory, non-dismissible modal on the member
    // portal until they backfill their DOB. `has_self_sub_user` is only
    // ever present (true/false) for primary member accounts — see
    // server.public_user_full — so this never fires for other roles.
    if (roles?.includes("member") && user.has_self_sub_user === false) {
        return <SelfSubUserGate />;
    }
    return <Outlet />;
}

export function RoleRedirect() {
    const { user, ready } = useAuth();
    if (!ready) return null;
    // Public visitors landing on an unknown URL get a branded 404 page.
    if (!user) return <Navigate to="/404" replace />;
    const active = user.active_role || user.role;
    if (active === "admin") return <Navigate to="/admin" replace />;
    if (active === "broker") return <Navigate to="/broker" replace />;
    if (active === "affiliate") return <Navigate to="/affiliate" replace />;
    return <Navigate to="/member" replace />;
}
